const SYMBOLS = { XOF: "FCFA", XAF: "FCFA", NGN: "₦", GHS: "₵", USD: "$", EUR: "€" };
const ZERO_DEC = ["XOF", "XAF"];

export function fmtMoney(amount, currency = "XOF") {
  const dec = ZERO_DEC.includes(currency) ? 0 : 2;
  const n = new Intl.NumberFormat("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(amount || 0);
  return `${n} ${SYMBOLS[currency] || currency}`;
}

export function fmtNumber(n) {
  return new Intl.NumberFormat("fr-FR").format(n || 0);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
